/**
 * component to render in nominations tab at How to Nominate page SCA
 */
const NominationsPage = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 px-5 py-4 font-public-sans"
      data-testid="nominations-page-component"
    >
      <p>Nominations are now closed.</p>
    </div>
  );
};

export default NominationsPage;
